export default "__VITE_ASSET__D34z4K$O__"